function i(n) {
  return n != null && n !== "";
}
export {
  i as isDefined
};
